<template>
  <div>
    <div class="tool" v-if="isShowTool">
      <div class="tool-left">
        <button
          v-for="item in dataSource.tool"
          :key="item.key"
          class="filter-item"
          @click="item.handleClick(item.name, $event)"
        >
          {{ item.name }}
        </button>
        <slot name="toolLeft"></slot>
      </div>
      <div class="tool-right">
        <slot name="toolRight"></slot>
      </div>
    </div>
    <el-table
      ref="table"
      v-loading="dataSource.loading"
      :border="dataSource.border ? true : false"
      style="width: 100%;"
      :class="{ 'no-data': !dataSource.data || !dataSource.data.length, 'language-wrap': dataSource.isWrap }"
      :data="dataSource.data"
      @row-click="getRowData"
      @selection-change="dataSource.handleSelectionChange"
    >
      <!-- 多选 -->
      <el-table-column
        v-if="dataSource.isSelection"
        :selectable="dataSource.selectable"
        type="selection"
        :width="dataSource.selectionWidth || 50"
        align="center"
      />
      <!-- 序号 -->
      <el-table-column
        v-if="dataSource.isIndex"
        type="index"
        label="序号"
        width="55"
        align="center"
      />
      <template v-for="item in dataSource.cols">
        <template v-if="!item.hide">
           <!-- 表格的列展示 特殊情况处理 比如要输入框 显示图片 -->
        <el-table-column v-if="item.isTemplate" :key="item.prop" v-bind="item" align="center" :show-overflow-tooltip="true">
          <template slot-scope="{ row }">
            <!-- 比如要输入框 显示图片等等 自己定义 -->
            <slot :name="item.prop" :row="row" />
          </template>
        </el-table-column>
        <!-- 需要特殊颜色显示字体-->
        <el-table-column
          v-if="item.isSpecial"
          :key="item.prop"
          v-bind="item"
          align="center"
        >
          <template slot-scope="scope">
            <span
              :class="item.isSpecialClass(scope.row[scope.column.property])"
              >{{ item.isSpecial(scope.row[scope.column.property]) }}</span
            >
          </template>
        </el-table-column>
        <!-- 图片 -->
        <el-table-column
          v-if="item.isImagePopover"
          :key="item.prop"
          v-bind="item"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover placement="right" title="" trigger="hover">
              <img
                class="image-popover"
                :src="
                  scope.row[scope.column.property] +
                  '?x-oss-process=image/quality,q_60'
                "
                alt=""
              />
              <img
                slot="reference"
                class="reference-img"
                :src="
                  scope.row[scope.column.property] +
                  '?x-oss-process=image/quality,q_10'
                "
                alt=""
              />
            </el-popover>
          </template>
        </el-table-column>
        <!-- 其它 -->
        <el-table-column
          v-if="
            !item.isImagePopover &&
            !item.isTemplate &&
            !item.isSpecial
          "
          :key="item.prop"
          v-bind="
            item.isCodeTableFormatter
              ? Object.assign({ formatter: item.isCodeTableFormatter }, item)
              : item
          "
          align="center"
          show-overflow-tooltip
        />
        </template>
       
      </template>
      <!-- 操作 -->
      <el-table-column
        v-if="dataSource.isOperation"
        :show-overflow-tooltip="dataSource.operation.overflowTooltip"
        v-bind="
          dataSource.data && dataSource.data.length ? { fixed: 'right' } : null
        "
        style="margin-right: 20px;"
        class-name="handle-td"
        label-class-name="tc"
        :width="dataSource.operation.width"
        :label="dataSource.operation.label"
        align="center"
      >
        <template slot-scope="scope">
          <template v-if="dataSource.operation.data.length > 0">
            <div class="btn">
              <div v-for="item in dataSource.operation.data" :key="item.label">
                <template v-if="item.type === 'button'">
                  <el-button
                    v-bind="item"
                    :type="item.type ? item.type : ''"
                    size="mini"
                    @click.native.prevent="
                      item.handleRow(scope.$index, scope.row, item.label)
                    "
                  >
                    {{ item.label }}
                  </el-button>
                </template>
                <template v-else-if="item.type === 'text'">
                  <el-link style="color: rgba(230, 194, 51, 1);" :underline="false" v-bind="item" @click.native.prevent="
                      item.handleRow(scope.$index, scope.row, item.label)
                    ">{{ item.label }}</el-link>
                </template>
              </div>
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        v-if="dataSource.pageData.total > 0 && dataSource.isPage"
        :current-page="dataSource.pageData.pageNum"
        :page-sizes="
          dataSource.pageData.pageSizes
            ? dataSource.pageData.pageSizes
            : [5, 10, 15, 20]
        "
        :page-size="dataSource.pageData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="dataSource.pageData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <slot name="customPage"></slot>
    </div>
  </div>
</template>

<script>
const dataSource = {
  data: [], // 表格数据
  cols: [], // 表格的列数据
  handleSelectionChange: () => {}, //点击行选中多选返回选中数组
  isSelection: false, // 表格有多选时设置
  isOperation: true, // 表格有操作列时设置
  isIndex: true, // 列表序号
  loading: true, // loading
  isPage: true,
  isWrap: false, // 是否换行
  pageData: {
    total: 0, // 总条数
    pageSize: 10, // 每页数量
    pageNum: 1, // 页码
    pageSizes: [ 10, 20, 50] // 每页数量
  },
  operation: {
    // 表格有操作列时设置
    label: '操作', // 列名
    width: '350', // 根据实际情况给宽度
    data: [
      {
        label: '冻结', // 操作名称
        type: 'info', //按钮类型
        handleRow: function () {} // 自定义事件
      }
    ]
  }
}
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => dataSource
    },
    tableKey: {
      type: Number,
      default: 0
    },
    isShowTool : {
      type : Boolean,
      default : false
    }
  },
  data() {
    return {}
  },
  watch: {
    'dataSource.cols': {
      handler() {
        this.$nextTick(this.$refs.table.doLayout) // 解决表格列变动的抖动问题
      },
      deep: true
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('changeSize', val)
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.$emit('changeNum', val)
      console.log(`当前页: ${val}`)
    },
    // 点击行即可选中
    getRowData(row) {
      this.$refs.table.toggleRowSelection(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.tool {
  /*margin-bottom: 15px;*/
  height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
 // margin-bottom: 0;
  .tool-left {
    text-align: left;
    .filter-item {
      border-radius: 2px;
      height: 34px;
      width: 80px;
      border: none;
      cursor: pointer;
      color: rgba(51, 51, 51, 1);
      background-color: rgba(234, 200, 62, 1);
      margin-right: 10px;
    }
  }
  .tool-right {
    text-align: right;
  }
}

  /deep/.el-table {
    &:before {
      background-color: transparent;
    }
    /deep/.el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #606266;
      border-radius: 4px;
    }
    /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
      background-color: rgba(33, 33, 35, 1);
    }

    th {
      background-color: rgba(27, 28, 31, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 14px;
      font-weight: 500;
      div {
        word-break: keep-all;
      }
    }
    tr {
      background-color: rgba(27, 28, 31, 1);
    }
    td {
      border: none;
    }
    .is-leaf {
      border: none;
    }
    tbody {
      .el-table__row {
        &:nth-child(odd) {
        background-color: rgb(22,22,24);
        }
        &:nth-child(even) {
          background-color: rgba(29, 30, 33, 1);
        }
        td {
          color: white;
          .cell {
            word-break: keep-all;
          }
        }
      }
      /deep/.hover-row {
        background-color: unset !important;
        td {
          background-color: unset !important;
        }
      }
      .el-table__row {
        &:hover {

          td {
            background-color: unset !important;
          }
        }
      }
    }
  }

  // 中日韩语言特殊换行
  .language-wrap {
  /deep/.el-table__row {
    td {
      .cell {
        word-break: break-all !important;
      }
    }
  }



  /deep/.hover-row {
    background-color: transparent;
    td {
      background-color: transparent;
    }
  }
  .el-table__row {
    &:hover {

      td {
        background-color: transparent;
      }
    }
  }
}


/*table*/
  /deep/.el-table__header-wrapper {

    /deep/.el-table__header {

      /deep/.has-gutter {
        tr {
          height: 60px;
          /*background-color: rgba(27, 28, 31, 1);*/
        }

      }
    }
  }

  /deep/.el-table__body-wrapper {

  }

  /deep/.is-scrolling-none {
    background-color: rgba(22, 22, 24, 1);
  }
  /deep/.el-table__empty-block {
    background-color: rgba(22, 22, 24, 1);
  }

  /deep/.el-table__fixed-right {
    &:before {
      background-color: transparent;
    }
    .el-table__fixed-header-wrapper {

      .el-table__header {

      }
      tr {
        height: 60px;
      }
    }
  }

  /deep/.el-table__fixed {
    &:before {
      height: 0;
    }
  }

  /deep/.el-loading-mask {
    background-color: transparent;
    .el-loading-spinner {
      .circular {
        .path {
          stroke: rgba(234, 200, 62, 1);
        }
      }
    }
  }


  /*分页*/
  .el-pagination {
    margin-top: 15px;
    text-align: right;
    /deep/.el-pagination__total {
      height: 34px;
      background-color: rgba(27, 28, 30, 1);
      color: rgba(255, 255, 255, 1);
      padding: 7px 13px;
      font-size: 14px;
      line-height: 20px;
      border-radius: 2px;
    }
    /deep/.el-pagination__sizes {


      .el-input__inner {
        height: 34px;
        background-color: rgba(27, 28, 30, 1);
        border: none;
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
      }
      .el-input__suffix-inner{

        .el-select__caret {
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    /deep/.btn-prev {
      height: 34px;
      background-color: rgba(27, 28, 30, 1);
      color: rgba(255, 255, 255, 1);
    }
    /deep/.el-pager {
      li {
        height: 34px;
        background-color: rgba(27, 28, 30, 1);
        color: rgba(255, 255, 255, 1);
        line-height: 34px;
        border-radius: 2px;
      }
      .active {
        color: rgba(51, 51, 51, 1);
        background-color: rgba(234, 200, 62, 1);
      }
    }
    /deep/.btn-next {
      height: 34px;
      background-color: rgba(27, 28, 30, 1);
      color: rgba(255, 255, 255, 1);
    }
    /deep/.el-pagination__jump {
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      .el-input__inner {
        height: 34px;
        background-color: rgba(27, 28, 30, 1);
        border: none;
        color: rgba(255, 255, 255, 1);
        font-size: 14px;
      }
    }
  }


</style>

<style lang="scss">
  .el-table {
    &:before {
      background-color: transparent;
    }
   .el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #606266;
      border-radius: 4px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      background-color: rgba(33, 33, 35, 1);
    }

    th {
      background-color: rgba(27, 28, 31, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 14px;
      font-weight: 500;
      div {
        word-break: keep-all;
      }
    }
    tr {
      background-color: rgba(27, 28, 31, 1);
    }
    td {
      border: none;
    }
    .is-leaf {
      border: none;
    }
    tbody {
      .el-table__row {
        &:nth-child(odd) {
          background-color: rgb(22,22,24);
        }
        &:nth-child(even) {
          background-color: rgba(29, 30, 33, 1);
        }
        td {
          color: white;
          .cell {
            word-break: keep-all;
          }
        }
      }
      .hover-row {
        background-color: transparent;
        td {
          background-color: transparent;
        }
      }
      .el-table__row {
        &:hover {

          td {
            background-color: transparent;
          }
        }
      }
    }
  }

  // 中日韩语言特殊换行
  .language-wrap {
    .el-table__row {
      td {
        .cell {
          word-break: break-all !important;
        }
      }
    }



    .hover-row {
      background-color: transparent;
      td {
        background-color: transparent;
      }
    }
    .el-table__row {
      &:hover {

        td {
          background-color: transparent;
        }
      }
    }
  }


  /*table*/
  .el-table__header-wrapper {

    .el-table__header {

      .has-gutter {
        tr {
          height: 60px;
          /*background-color: rgba(27, 28, 31, 1);*/
        }

      }
    }
  }

  .el-table__body-wrapper {

  }

  .is-scrolling-none {
    background-color: rgba(22, 22, 24, 1);
  }
  .el-table__empty-block {
    background-color: rgba(22, 22, 24, 1);
  }

  .el-table__fixed-right {
    &:before {
      background-color: transparent;
    }
    .el-table__fixed-header-wrapper {

      .el-table__header {

      }
      tr {
        height: 60px;
      }
    }
  }

  .el-table__fixed {
    &:before {
      height: 0;
    }
  }

  .el-loading-mask {
    background-color: transparent;
    .el-loading-spinner {
      .circular {
        .path {
          stroke: rgba(234, 200, 62, 1);
        }
      }
    }
  }
</style>

